<template>
	<!-- 左侧绘图工具栏 -->
	<div class="left-panel-container">
		<div class="klinecharts-pro-content">
			<div class="klinecharts-pro-drawing-bar">
				<!-- 绘图工具下拉菜单 -->
				<div class="item drawing-tool-item" tabindex="0" @click="toggleDrawingToolDropdown" :class="{ 'tool-active': activeTool === 'drawing' }">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<path d="M12.41465,11L18.5,11C18.7761,11,19,11.22386,19,11.5C19,11.77614,18.7761,12,18.5,12L12.41465,12C12.20873,12.5826,11.65311,13,11,13C10.34689,13,9.79127,12.5826,9.58535,12L3.5,12C3.223857,12,3,11.77614,3,11.5C3,11.22386,3.223857,11,3.5,11L9.58535,11C9.79127,10.417404,10.34689,10,11,10C11.65311,10,12.20873,10.417404,12.41465,11Z" stroke-opacity="0" stroke="none"></path>
						</svg>
					</span>
					<div class="icon-arrow" :class="{ 'arrow-rotated': showDrawingDropdown }">
						<svg viewBox="0 0 4 6" class="">
							<path d="M1.07298,0.159458C0.827521,-0.0531526,0.429553,-0.0531526,0.184094,0.159458C-0.0613648,0.372068,-0.0613648,0.716778,0.184094,0.929388L2.61275,3.03303L0.260362,5.07061C0.0149035,5.28322,0.0149035,5.62793,0.260362,5.84054C0.505822,6.05315,0.903789,6.05315,1.14925,5.84054L3.81591,3.53075C4.01812,3.3556,4.05374,3.0908,3.92279,2.88406C3.93219,2.73496,3.87113,2.58315,3.73964,2.46925L1.07298,0.159458Z" stroke="none" stroke-opacity="0"></path>
						</svg>
					</div>
					
					<!-- 绘图工具下拉菜单 -->
					<div v-if="showDrawingDropdown" class="drawing-tool-dropdown" @click.stop>
						<div class="dropdown-item" @click="handleSelectDrawingTool('horizontal-line')" :class="{ 'selected': selectedDrawingTool === 'horizontal-line' }">
							<span class="tool-icon">—</span> {{ $t('Trading.horizontalLine') || '水平直线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('horizontal-ray')" :class="{ 'selected': selectedDrawingTool === 'horizontal-ray' }">
							<span class="tool-icon">→</span> {{ $t('Trading.horizontalRay') || '水平射线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('horizontal-segment')" :class="{ 'selected': selectedDrawingTool === 'horizontal-segment' }">
							<span class="tool-icon">─</span> {{ $t('Trading.horizontalSegment') || '水平线段' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('vertical-line')" :class="{ 'selected': selectedDrawingTool === 'vertical-line' }">
							<span class="tool-icon">│</span> {{ $t('Trading.verticalLine') || '垂直直线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('vertical-ray')" :class="{ 'selected': selectedDrawingTool === 'vertical-ray' }">
							<span class="tool-icon">↓</span> {{ $t('Trading.verticalRay') || '垂直射线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('vertical-segment')" :class="{ 'selected': selectedDrawingTool === 'vertical-segment' }">
							<span class="tool-icon">┃</span> {{ $t('Trading.verticalSegment') || '垂直线段' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('line')" :class="{ 'selected': selectedDrawingTool === 'line' }">
							<span class="tool-icon">/</span> {{ $t('Trading.straightLine') || '直线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('ray')" :class="{ 'selected': selectedDrawingTool === 'ray' }">
							<span class="tool-icon">↗</span> {{ $t('Trading.ray') || '射线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('segment')" :class="{ 'selected': selectedDrawingTool === 'segment' }">
							<span class="tool-icon">\\</span> {{ $t('Trading.segment') || '线段' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('arrow')" :class="{ 'selected': selectedDrawingTool === 'arrow' }">
							<span class="tool-icon">➜</span> {{ $t('Trading.arrow') || '箭头' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('price-line')" :class="{ 'selected': selectedDrawingTool === 'price-line' }">
							<span class="tool-icon">⟷</span> {{ $t('Trading.priceLine') || '价格线' }}
						</div>
					</div>
				</div>

				<!-- 通道工具下拉菜单 -->
				<div class="item drawing-tool-item" tabindex="0" @click="toggleChannelDropdown" :class="{ 'tool-active': activeTool === 'channel' }">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<path d="M3.146447,14.178126025390625C2.9511847,13.982826025390626,2.9511847,13.666226025390625,3.146447,13.470926025390625L7.39146,9.225966025390626C7.35417,9.095106025390624,7.33421,8.956946025390625,7.33421,8.814116025390625C7.33421,7.985696025390625,8.00578,7.314116025390625,8.834209999999999,7.314116025390625C8.97703,7.314116025390625,9.11519,7.334086025390625,9.24605,7.371366025390625L13.753,2.864373025390625C13.9483,2.669110325390625,14.2649,2.669110325390625,14.4602,2.864373025390625C14.6554,3.059635025390625,14.6554,3.376217025390625,14.4602,3.571479025390625L10.06916,7.962476025390625C10.23631,8.204386025390626,10.334209999999999,8.497826025390625,10.334209999999999,8.814116025390625C10.334209999999999,9.642546025390626,9.66264,10.314116025390625,8.834209999999999,10.314116025390625C8.51791,10.314116025390625,8.22448,10.216226025390625,7.98256,10.049076025390626L3.853554,14.178126025390625C3.658291,14.373326025390625,3.341709,14.373326025390625,3.146447,14.178126025390625ZM7.67736,19.188526025390626C7.4821,18.993226025390626,7.4821,18.676626025390625,7.67736,18.481426025390626L9.9804,16.178326025390625C9.88669,15.982526025390625,9.834209999999999,15.763226025390624,9.834209999999999,15.531626025390626C9.834209999999999,14.703226025390626,10.50578,14.031626025390626,11.33421,14.031626025390626C11.56579,14.031626025390626,11.78511,14.084126025390624,11.98093,14.177826025390624L13.9804,12.178356025390626C13.8867,11.982536025390624,13.8342,11.763216025390625,13.8342,11.531636025390625C13.8342,10.703206025390624,14.5058,10.031636025390625,15.3342,10.031636025390625C15.5658,10.031636025390625,15.7851,10.084116025390625,15.9809,10.177826025390626L18.284,7.874796025390625C18.4792,7.679536025390625,18.7958,7.679536025390625,18.9911,7.874796025390625C19.1863,8.070056025390624,19.1863,8.386636025390626,18.9911,8.581906025390625L16.688000000000002,10.884936025390624C16.7817,11.080756025390626,16.8342,11.300066025390626,16.8342,11.531636025390625C16.8342,12.360066025390624,16.162599999999998,13.031626025390626,15.3342,13.031626025390626C15.1026,13.031626025390626,14.8833,12.979126025390626,14.6875,12.885426025390625L12.68803,14.884926025390625C12.78174,15.080726025390625,12.83421,15.300026025390626,12.83421,15.531626025390626C12.83421,16.360026025390624,12.16264,17.031626025390626,11.33421,17.031626025390626C11.10264,17.031626025390626,10.88333,16.979126025390627,10.68751,16.885426025390625L8.38446,19.188526025390626C8.1892,19.383726025390626,7.87262,19.383726025390626,7.67736,19.188526025390626Z" stroke-opacity="0" stroke="none"></path>
						</svg>
					</span>
					<div class="icon-arrow" :class="{ 'arrow-rotated': showChannelDropdown }">
						<svg viewBox="0 0 4 6" class="">
							<path d="M1.07298,0.159458C0.827521,-0.0531526,0.429553,-0.0531526,0.184094,0.159458C-0.0613648,0.372068,-0.0613648,0.716778,0.184094,0.929388L2.61275,3.03303L0.260362,5.07061C0.0149035,5.28322,0.0149035,5.62793,0.260362,5.84054C0.505822,6.05315,0.903789,6.05315,1.14925,5.84054L3.81591,3.53075C4.01812,3.3556,4.05374,3.0908,3.92279,2.88406C3.93219,2.73496,3.87113,2.58315,3.73964,2.46925L1.07298,0.159458Z" stroke="none" stroke-opacity="0"></path>
						</svg>
					</div>
					
					<!-- 通道工具下拉菜单 -->
					<div v-if="showChannelDropdown" class="drawing-tool-dropdown" @click.stop>
						<div class="dropdown-item" @click="handleSelectDrawingTool('price-channel')" :class="{ 'selected': selectedDrawingTool === 'price-channel' }">
							<span class="tool-icon">⫽</span> {{ $t('Trading.priceChannel') || '价格通道线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('parallel-straight-line')" :class="{ 'selected': selectedDrawingTool === 'parallel-straight-line' }">
							<span class="tool-icon">‖</span> {{ $t('Trading.parallelLine') || '平行直线' }}
						</div>
					</div>
				</div>

				<!-- 形状工具下拉菜单 -->
				<div class="item drawing-tool-item" tabindex="0" @click="toggleShapeDropdown" :class="{ 'tool-active': activeTool === 'shape' }">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<ellipse cx="10.5" cy="11.5" rx="1.5" ry="1.5" stroke-opacity="0" stroke="none"></ellipse>
							<ellipse cx="17.5" cy="11.5" rx="1.5" ry="1.5" stroke-opacity="0" stroke="none"></ellipse>
							<ellipse cx="10.5" cy="11.5" rx="7" ry="7" fill-opacity="0" fill="none" stroke-opacity="1" stroke-width="1"></ellipse>
						</svg>
					</span>
					<div class="icon-arrow" :class="{ 'arrow-rotated': showShapeDropdown }">
						<svg viewBox="0 0 4 6" class="">
							<path d="M1.07298,0.159458C0.827521,-0.0531526,0.429553,-0.0531526,0.184094,0.159458C-0.0613648,0.372068,-0.0613648,0.716778,0.184094,0.929388L2.61275,3.03303L0.260362,5.07061C0.0149035,5.28322,0.0149035,5.62793,0.260362,5.84054C0.505822,6.05315,0.903789,6.05315,1.14925,5.84054L3.81591,3.53075C4.01812,3.3556,4.05374,3.0908,3.92279,2.88406C3.93219,2.73496,3.87113,2.58315,3.73964,2.46925L1.07298,0.159458Z" stroke="none" stroke-opacity="0"></path>
						</svg>
					</div>
					
					<!-- 形状工具下拉菜单 -->
					<div v-if="showShapeDropdown" class="drawing-tool-dropdown" @click.stop>
						<div class="dropdown-item" @click="handleSelectDrawingTool('circle')" :class="{ 'selected': selectedDrawingTool === 'circle' }">
							<span class="tool-icon">●</span> {{ $t('Trading.circle') || '圆' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('rectangle')" :class="{ 'selected': selectedDrawingTool === 'rectangle' }">
							<span class="tool-icon">▭</span> {{ $t('Trading.rectangle') || '矩形' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('parallelogram')" :class="{ 'selected': selectedDrawingTool === 'parallelogram' }">
							<span class="tool-icon">▱</span> {{ $t('Trading.parallelogram') || '平行四边形' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('triangle')" :class="{ 'selected': selectedDrawingTool === 'triangle' }">
							<span class="tool-icon">▲</span> {{ $t('Trading.triangle') || '三角形' }}
						</div>
					</div>
				</div>

				<!-- 斐波那契/江恩工具下拉菜单 -->
				<div class="item drawing-tool-item" tabindex="0" @click="toggleFibonacciDropdown" :class="{ 'tool-active': activeTool === 'fibonacci' }">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<path d="M13.1889,6C12.98303,6.582599999999999,12.42741,7,11.7743,7C11.12119,7,10.565570000000001,6.582599999999999,10.35965,6L3.5,6C3.223857,6,3,5.77614,3,5.5C3,5.22386,3.223857,5,3.5,5L10.35965,5C10.565570000000001,4.417404,11.12119,4,11.7743,4C12.42741,4,12.98303,4.417404,13.1889,5L18.5,5C18.7761,5,19,5.22386,19,5.5C19,5.77614,18.7761,6,18.5,6L13.1889,6ZM3,8.5C3,8.22386,3.223857,8,3.5,8L18.5,8C18.7761,8,19,8.22386,19,8.5C19,8.77614,18.7761,9,18.5,9L3.5,9C3.223857,9,3,8.77614,3,8.5ZM3.278549,11.5C3.278549,11.22386,3.502407,11,3.778549,11L18.7785,11C19.0547,11,19.2785,11.22386,19.2785,11.5C19.2785,11.77614,19.0547,12,18.7785,12L3.778549,12C3.502407,12,3.278549,11.77614,3.278549,11.5ZM3.139267,14.5C3.139267,14.2239,3.363124,14,3.6392670000000003,14L18.6393,14C18.915399999999998,14,19.1393,14.2239,19.1393,14.5C19.1393,14.7761,18.915399999999998,15,18.6393,15L3.6392670000000003,15C3.363124,15,3.139267,14.7761,3.139267,14.5ZM13.1889,18C12.98303,18.5826,12.42741,19,11.7743,19C11.12119,19,10.565570000000001,18.5826,10.35965,18L3.778549,18C3.502407,18,3.278549,17.7761,3.278549,17.5C3.278549,17.2239,3.502407,17,3.778549,17L10.35965,17C10.565570000000001,16.4174,11.12119,16,11.7743,16C12.42741,16,12.98303,16.4174,13.1889,17L18.7785,17C19.0547,17,19.2785,17.2239,19.2785,17.5C19.2785,17.7761,19.0547,18,18.7785,18L13.1889,18Z" stroke-opacity="0" stroke="none"></path>
						</svg>
					</span>
					<div class="icon-arrow" :class="{ 'arrow-rotated': showFibonacciDropdown }">
						<svg viewBox="0 0 4 6" class="">
							<path d="M1.07298,0.159458C0.827521,-0.0531526,0.429553,-0.0531526,0.184094,0.159458C-0.0613648,0.372068,-0.0613648,0.716778,0.184094,0.929388L2.61275,3.03303L0.260362,5.07061C0.0149035,5.28322,0.0149035,5.62793,0.260362,5.84054C0.505822,6.05315,0.903789,6.05315,1.14925,5.84054L3.81591,3.53075C4.01812,3.3556,4.05374,3.0908,3.92279,2.88406C3.93219,2.73496,3.87113,2.58315,3.73964,2.46925L1.07298,0.159458Z" stroke="none" stroke-opacity="0"></path>
						</svg>
					</div>
					
					<!-- 斐波那契/江恩工具下拉菜单 -->
					<div v-if="showFibonacciDropdown" class="drawing-tool-dropdown" @click.stop>
						<div class="dropdown-item" @click="handleSelectDrawingTool('fibonacci-retracement')" :class="{ 'selected': selectedDrawingTool === 'fibonacci-retracement' }">
							<span class="tool-icon">⌇</span> {{ $t('Trading.fibonacciRetracement') || '斐波那契回调直线' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('fibonacci-grid')" :class="{ 'selected': selectedDrawingTool === 'fibonacci-grid' }">
							<span class="tool-icon">⊞</span> {{ $t('Trading.fibonacciGrid') || '斐波那契梯格' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('fibonacci-circle')" :class="{ 'selected': selectedDrawingTool === 'fibonacci-circle' }">
							<span class="tool-icon">◎</span> {{ $t('Trading.fibonacciCircle') || '斐波那契圆环' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('fibonacci-spiral')" :class="{ 'selected': selectedDrawingTool === 'fibonacci-spiral' }">
							<span class="tool-icon">◉</span> {{ $t('Trading.fibonacciSpiral') || '斐波那契螺旋' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('fibonacci-fan')" :class="{ 'selected': selectedDrawingTool === 'fibonacci-fan' }">
							<span class="tool-icon">⊿</span> {{ $t('Trading.fibonacciFan') || '斐波那契速度阻力扇' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('fibonacci-extension')" :class="{ 'selected': selectedDrawingTool === 'fibonacci-extension' }">
							<span class="tool-icon">⊣</span> {{ $t('Trading.fibonacciExtension') || '斐波那契趋势扩展' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('gann-box')" :class="{ 'selected': selectedDrawingTool === 'gann-box' }">
							<span class="tool-icon">▦</span> {{ $t('Trading.gannBox') || '江恩箱' }}
						</div>
					</div>
				</div>

				<!-- 波浪形态/谐波形态工具下拉菜单 -->
				<div class="item drawing-tool-item" tabindex="0" @click="toggleWaveDropdown" :class="{ 'tool-active': activeTool === 'wave' }">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<path d="M5.92159,5.93994C6.04014,5.90529,6.152620000000001,5.85639,6.25704,5.79523L9.12729,9.89437C9.045449999999999,10.07959,9,10.28449,9,10.5C9,10.79522,9.08529,11.07053,9.232569999999999,11.30262L4.97573,16.7511L5.92159,5.93994ZM4.92259,5.8848400000000005C4.38078,5.658659999999999,4,5.1238,4,4.5C4,3.671573,4.67157,3,5.5,3C6.2157,3,6.81433,3.50124,6.96399,4.17183L15.1309,4.88634C15.3654,4.36387,15.8902,4,16.5,4C17.328400000000002,4,18,4.67157,18,5.5C18,6.08983,17.659599999999998,6.60015,17.1645,6.84518L18.4264,14.0018C18.4508,14.0006,18.4753,14,18.5,14C19.3284,14,20,14.6716,20,15.5C20,16.328400000000002,19.3284,17,18.5,17C17.932499999999997,17,17.4386,16.6849,17.183799999999998,16.22L5.99686,18.5979C5.946429999999999,19.3807,5.29554,20,4.5,20C3.671573,20,3,19.3284,3,18.5C3,17.869300000000003,3.389292,17.3295,3.94071,17.1077L4.92259,5.8848400000000005ZM5.72452,17.6334C5.69799,17.596,5.6698,17.5599,5.64004,17.525100000000002L10.01843,11.92103C10.16958,11.97223,10.33155,12,10.5,12C10.80059,12,11.08052,11.91158,11.31522,11.75934L17.0606,15.0765C17.0457,15.1271,17.0335,15.1789,17.023899999999998,15.2317L5.72452,17.6334ZM11.92855,10.95875L17.4349,14.1379L16.1699,6.96356C15.9874,6.92257,15.8174,6.8483,15.6667,6.74746L11.99771,10.4165C11.99923,10.44414,12,10.47198,12,10.5C12,10.66,11.97495,10.814160000000001,11.92855,10.95875ZM10.5,9C10.259830000000001,9,10.03285,9.05644,9.83159,9.15679L7.04919,5.1831L15.0493,5.88302C15.054,5.90072,15.059,5.91829,15.0643,5.9357299999999995L11.56066,9.43934C11.28921,9.16789,10.91421,9,10.5,9Z" stroke-opacity="0" fill-rule="evenodd" fill-opacity="1"></path>
						</svg>
					</span>
					<div class="icon-arrow" :class="{ 'arrow-rotated': showWaveDropdown }">
						<svg viewBox="0 0 4 6" class="">
							<path d="M1.07298,0.159458C0.827521,-0.0531526,0.429553,-0.0531526,0.184094,0.159458C-0.0613648,0.372068,-0.0613648,0.716778,0.184094,0.929388L2.61275,3.03303L0.260362,5.07061C0.0149035,5.28322,0.0149035,5.62793,0.260362,5.84054C0.505822,6.05315,0.903789,6.05315,1.14925,5.84054L3.81591,3.53075C4.01812,3.3556,4.05374,3.0908,3.92279,2.88406C3.93219,2.73496,3.87113,2.58315,3.73964,2.46925L1.07298,0.159458Z" stroke="none" stroke-opacity="0"></path>
						</svg>
					</div>
					
					<!-- 波浪形态/谐波形态工具下拉菜单 -->
					<div v-if="showWaveDropdown" class="drawing-tool-dropdown" @click.stop>
						<div class="dropdown-item" @click="handleSelectDrawingTool('xabcd-pattern')" :class="{ 'selected': selectedDrawingTool === 'xabcd-pattern' }">
							<span class="tool-icon">⚡</span> {{ $t('Trading.xabcdPattern') || 'XABCD形态' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('abcd-pattern')" :class="{ 'selected': selectedDrawingTool === 'abcd-pattern' }">
							<span class="tool-icon">△</span> {{ $t('Trading.abcdPattern') || 'ABCD形态' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('wave-3')" :class="{ 'selected': selectedDrawingTool === 'wave-3' }">
							<span class="tool-icon">〜</span> {{ $t('Trading.wave3') || '三浪' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('wave-5')" :class="{ 'selected': selectedDrawingTool === 'wave-5' }">
							<span class="tool-icon">≈</span> {{ $t('Trading.wave5') || '五浪' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('wave-8')" :class="{ 'selected': selectedDrawingTool === 'wave-8' }">
							<span class="tool-icon">≋</span> {{ $t('Trading.wave8') || '八浪' }}
						</div>
						<div class="dropdown-item" @click="handleSelectDrawingTool('wave-custom')" :class="{ 'selected': selectedDrawingTool === 'wave-custom' }">
							<span class="tool-icon">∿</span> {{ $t('Trading.waveCustom') || '任意浪' }}
						</div>
					</div>
				</div>

				<span class="split-line"></span>

				<!-- 磁铁吸附模式下拉菜单 -->
				<div class="item drawing-tool-item" tabindex="0" @click="toggleMagnetDropdown" :class="{ 'tool-active': activeTool === 'magnet' }">
					<span style="width:32px;height:32px">
						<svg viewBox="0 0 22 22" class="icon-overlay">
							<path d="M4.727219638671875,8.007996215820313L9.973849638671876,2.7629472158203123C10.167279638671875,2.5696791158203123,10.480729638671875,2.5696791158203123,10.674169638671875,2.7629472158203123L13.223329638671874,5.311756215820313C13.416929638671874,5.505236215820313,13.416929638671874,5.8189862158203125,13.223329638671874,6.012466215820313L7.977129638671875,11.257906215820313C7.379859638671875,11.855176215820313,7.407609638671875,12.909396215820312,8.033809638671876,13.535596215820313C8.660409638671876,14.162596215820313,9.713849638671874,14.189996215820312,10.311129638671876,13.591896215820313L15.556929638671875,8.346066215820311C15.750429638671875,8.152526215820313,16.064229638671875,8.152526215820313,16.257629638671872,8.346066215820311L18.806529638671876,10.895266215820312C19.000029638671876,11.088746215820313,19.000029638671876,11.402496215820312,18.806529638671876,11.595976215820313L13.560629638671875,16.841796215820313C11.165619638671876,19.237196215820312,7.197149638671875,19.19919621582031,4.783499638671875,16.785496215820313C2.3698426386718747,14.371896215820312,2.331397638671875,10.403416215820313,4.727219638671875,8.007996215820313ZM12.172299638671875,5.662106215820312L10.323809638671875,3.8136162158203124L5.4287196386718755,8.709096215820313C3.422893638671875,10.714536215820312,3.4549956386718748,14.055196215820313,5.484999638671875,16.08479621582031C7.514609638671875,18.114796215820313,10.855289638671875,18.146496215820314,12.860719638671876,16.141096215820312L15.465629638671874,13.535796215820312L14.090929638671875,12.160756215820312L14.791629638671875,11.460436215820312L16.166229638671876,12.834996215820313L17.755829638671877,11.245226215820313L15.907729638671874,9.396736215820312L11.011839638671875,14.292596215820312C10.042809638671875,15.262396215820312,8.418249638671874,15.243796215820312,7.406019638671875,14.306496215820312L7.333099638671875,14.236296215820312C6.327599638671876,13.230796215820313,6.284009638671876,11.550396215820312,7.276419638671875,10.557586215820312L9.882199638671874,7.952026215820313L8.501079638671875,6.570906215820313L9.201789638671876,5.870186215820313L10.582939638671874,7.251336215820312L12.172299638671875,5.662106215820312Z" stroke-opacity="0" fill-rule="evenodd" fill-opacity="1"></path>
						</svg>
					</span>
					<div class="icon-arrow" :class="{ 'arrow-rotated': showMagnetDropdown }">
						<svg viewBox="0 0 4 6" class="">
							<path d="M1.07298,0.159458C0.827521,-0.0531526,0.429553,-0.0531526,0.184094,0.159458C-0.0613648,0.372068,-0.0613648,0.716778,0.184094,0.929388L2.61275,3.03303L0.260362,5.07061C0.0149035,5.28322,0.0149035,5.62793,0.260362,5.84054C0.505822,6.05315,0.903789,6.05315,1.14925,5.84054L3.81591,3.53075C4.01812,3.3556,4.05374,3.0908,3.92279,2.88406C3.93219,2.73496,3.87113,2.58315,3.73964,2.46925L1.07298,0.159458Z" stroke="none" stroke-opacity="0"></path>
						</svg>
					</div>
					
					<!-- 磁铁吸附模式下拉菜单 -->
					<div v-if="showMagnetDropdown" class="drawing-tool-dropdown" @click.stop>
						<div class="dropdown-item" @click="handleSelectMagnetMode('weak')" :class="{ 'selected': magnetMode === 'weak' }">
							<span class="tool-icon">🧲</span> {{ $t('Trading.weakMagnet') || '弱磁模式' }}
						</div>
						<div class="dropdown-item" @click="handleSelectMagnetMode('strong')" :class="{ 'selected': magnetMode === 'strong' }">
							<span class="tool-icon">🔗</span> {{ $t('Trading.strongMagnet') || '强磁模式' }}
						</div>
					</div>
				</div>

				<!-- 锁定图标 -->
				<div class="item">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<defs><clipPath id="master_svg0_151_620"><rect x="0" y="0" width="22" height="22" rx="0"></rect></clipPath></defs>
							<g clip-path="url(#master_svg0_151_620)">
								<path d="M8.38461,9.76923L15.6538,9.76923C16.6538,9.76923,17.4615,10.576920000000001,17.4615,11.576920000000001L17.4615,17.1923C17.4615,18.1923,16.6538,19,15.6538,19L5.80769,19C4.807692,19,4,18.1923,4,17.1923L4,11.576920000000001C4,10.576920000000001,4.807693,9.76923,5.80769,9.76923L7.23077,9.76923L7.23077,7.576919999999999C7.23077,5.61538,8.88462,4,10.88462,4C12.46154,4,13.84615,4.961539,14.3462,6.423080000000001C14.4615,6.73077,14.3077,7.038460000000001,14,7.15385C13.69231,7.26923,13.38461,7.11538,13.26923,6.80769C12.92308,5.80769,11.96154,5.15385,10.88462,5.15385C9.5,5.15385,8.38461,6.23077,8.38461,7.576919999999999L8.38461,9.76923ZM15.6538,17.8462C16,17.8462,16.3077,17.5385,16.3077,17.1923L16.3077,11.576920000000001C16.3077,11.23077,16,10.923079999999999,15.6538,10.923079999999999L5.80769,10.923079999999999C5.46154,10.923079999999999,5.15385,11.23077,5.15385,11.576920000000001L5.15385,17.1923C5.15385,17.5385,5.46154,17.8462,5.80769,17.8462L15.6538,17.8462ZM10.153839999999999,12.65385C10.153839999999999,12.34615,10.42307,12.07692,10.73076,12.07692C11.03846,12.07692,11.307690000000001,12.34615,11.307690000000001,12.65385L11.307690000000001,14.5769C11.307690000000001,14.8846,11.03846,15.1538,10.73076,15.1538C10.42307,15.1538,10.153839999999999,14.8846,10.153839999999999,14.5769L10.153839999999999,12.65385Z" stroke-opacity="0" fill-rule="evenodd" fill-opacity="1"></path>
							</g>
						</svg>
					</span>
				</div>

				<!-- 眼睛图标：切换绘图显示/隐藏 -->
				<div class="item" @click="handleToggleDrawingVisibility" :class="{ 'tool-active': drawingsVisible }">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<path d="M11,17C5.80945,17,3.667717,12.85,3.113386,11.575C2.9622047,11.2,2.9622047,10.8,3.113386,10.425C3.667717,9.15,5.80945,5,11,5C16.165399999999998,5,18.3323,9.15,18.8866,10.425C19.0378,10.8,19.0378,11.2,18.8866,11.575C18.3323,12.85,16.165399999999998,17,11,17ZM4.04567,10.8C3.995276,10.925,3.995276,11.05,4.04567,11.175C4.52441,12.325,6.43937,16,11,16C15.5606,16,17.4756,12.325,17.9543,11.2C18.0047,11.075,18.0047,10.95,17.9543,10.825C17.4756,9.675,15.5606,6,11,6C6.43937,6,4.52441,9.675,4.04567,10.8ZM11,13.5C9.61417,13.5,8.480319999999999,12.375,8.480319999999999,11C8.480319999999999,9.625,9.61417,8.5,11,8.5C12.38583,8.5,13.5197,9.625,13.5197,11C13.5197,12.375,12.38583,13.5,11,13.5ZM11,9.5C10.1685,9.5,9.48819,10.175,9.48819,11C9.48819,11.825,10.1685,12.5,11,12.5C11.8315,12.5,12.51181,11.825,12.51181,11C12.51181,10.175,11.8315,9.5,11,9.5Z" stroke-opacity="0" fill-opacity="1"></path>
						</svg>
					</span>
				</div>

				<span class="split-line"></span>

				<!-- 删除图标：删除所有绘图 -->
				<div class="item" @click="handleClearAllDrawings">
					<span style="width:32px;height:32px">
						<svg class="icon-overlay" viewBox="0 0 22 22">
							<path d="M16.966900000000003,8.67144C16.6669,8.67144,16.4247,8.91558,16.4247,9.21802L16.4247,16.631500000000003C16.4247,17.322,16.007199999999997,17.9068,15.5139,17.9068L13.93072,17.9068L13.93072,9.2162C13.93072,8.91741,13.68675,8.67144,13.38855,8.67144C13.09036,8.67144,12.84639,8.91741,12.84639,9.21802L12.84639,17.9068L10.151810000000001,17.9068L10.151810000000001,9.21802C10.151810000000001,8.91741,9.90783,8.67144,9.609639999999999,8.67144C9.31145,8.67144,9.06747,8.67144,9.06747,9.219850000000001L9.06747,17.9068L7.48614,17.9068C6.99277,17.9068,6.5753,17.322,6.5753,16.631500000000003L6.5753,9.21802C6.5753,8.91558,6.333130000000001,8.67144,6.03313,8.67144C5.73313,8.67144,5.49096,8.91558,5.49096,9.21802L5.49096,16.631500000000003C5.49096,17.9378,6.385540000000001,19,7.48614,19L15.512,19C16.6127,19,17.509,17.9378,17.509,16.631500000000003L17.509,9.21802C17.509,8.91558,17.2669,8.67144,16.966900000000003,8.67144ZM18.4578,6.21183L4.542169,6.21183C4.243976,6.21183,4,6.45779,4,6.75841C4,7.05903,4.243976,7.30499,4.542169,7.30499L18.4578,7.30499C18.756,7.30499,19,7.05903,19,6.75841C19,6.45779,18.756,6.21183,18.4578,6.21183ZM8.68072,5.10045L14.3193,5.10045C14.6175,5.10045,14.8614,4.852666,14.8614,4.550225C14.8614,4.247783,14.6175,4,14.3193,4L8.68072,4C8.38253,4,8.13855,4.247783,8.13855,4.550225C8.13855,4.852666,8.38253,5.10045,8.68072,5.10045Z" stroke-opacity="0" fill-opacity="1"></path>
						</svg>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DrawingToolbar',
	props: {
		selectedDrawingTool: String,
		magnetMode: String,
		drawingsVisible: Boolean
	},
	data() {
		return {
			activeTool: '',
			showDrawingDropdown: false,
			showChannelDropdown: false,
			showShapeDropdown: false,
			showFibonacciDropdown: false,
			showWaveDropdown: false,
			showMagnetDropdown: false
		}
	},
	methods: {
		toggleDrawingToolDropdown() {
			this.showDrawingDropdown = !this.showDrawingDropdown
			this.activeTool = this.showDrawingDropdown ? 'drawing' : ''
			this.closeOtherDropdowns('drawing')
		},
		toggleChannelDropdown() {
			this.showChannelDropdown = !this.showChannelDropdown
			this.activeTool = this.showChannelDropdown ? 'channel' : ''
			this.closeOtherDropdowns('channel')
		},
		toggleShapeDropdown() {
			this.showShapeDropdown = !this.showShapeDropdown
			this.activeTool = this.showShapeDropdown ? 'shape' : ''
			this.closeOtherDropdowns('shape')
		},
		toggleFibonacciDropdown() {
			this.showFibonacciDropdown = !this.showFibonacciDropdown
			this.activeTool = this.showFibonacciDropdown ? 'fibonacci' : ''
			this.closeOtherDropdowns('fibonacci')
		},
		toggleWaveDropdown() {
			this.showWaveDropdown = !this.showWaveDropdown
			this.activeTool = this.showWaveDropdown ? 'wave' : ''
			this.closeOtherDropdowns('wave')
		},
		toggleMagnetDropdown() {
			this.showMagnetDropdown = !this.showMagnetDropdown
			this.activeTool = this.showMagnetDropdown ? 'magnet' : ''
			this.closeOtherDropdowns('magnet')
		},
		closeOtherDropdowns(except) {
			if (except !== 'drawing') this.showDrawingDropdown = false
			if (except !== 'channel') this.showChannelDropdown = false
			if (except !== 'shape') this.showShapeDropdown = false
			if (except !== 'fibonacci') this.showFibonacciDropdown = false
			if (except !== 'wave') this.showWaveDropdown = false
			if (except !== 'magnet') this.showMagnetDropdown = false
		},
		handleSelectDrawingTool(tool) {
			this.$emit('select-drawing-tool', tool)
			this.closeOtherDropdowns('')
			this.activeTool = ''
		},
		handleSelectMagnetMode(mode) {
			this.$emit('select-magnet-mode', mode)
			this.closeOtherDropdowns('')
			this.activeTool = ''
		},
		handleToggleDrawingVisibility() {
			this.$emit('toggle-drawing-visibility')
		},
		handleClearAllDrawings() {
			this.$emit('clear-all-drawings')
		}
	}
}
</script>

<style scoped>
/* 左侧工具栏容器 */
.left-panel-container {
	width: 56px;
	background: var(--toolbar-bg);
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
	transition: background-color 0.3s ease;
	z-index: 10;
}

.klinecharts-pro-content {
	width: 100%;
}

.klinecharts-pro-drawing-bar {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
}

.item {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 4px;
	transition: all 0.2s;
	position: relative;
}

.item:hover {
	background: var(--hover-bg, rgba(0, 0, 0, 0.05));
}

.drawing-tool-item {
	width: 48px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 4px 0 8px;
	cursor: pointer;
	border-radius: 4px;
	transition: all 0.2s;
	position: relative;
}

.drawing-tool-item > span {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.drawing-tool-item:hover {
	background: var(--hover-bg, rgba(0, 0, 0, 0.05));
}

.tool-active {
	background: var(--active-bg, rgba(58, 105, 250, 0.1));
}

.icon-overlay {
	fill: var(--text-primary);
	transition: fill 0.3s ease;
}

.icon-arrow {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 8px;
	height: 8px;
	flex-shrink: 0;
	transition: transform 0.2s;
}

.icon-arrow svg {
	width: 100%;
	height: 100%;
	fill: var(--text-secondary);
	transition: fill 0.3s ease;
}

.arrow-rotated {
	transform: rotate(90deg);
}

.split-line {
	width: 32px;
	height: 1px;
	background: var(--border-color);
	margin: 4px 0;
	transition: background-color 0.3s ease;
}

/* 下拉菜单样式 */
.drawing-tool-dropdown {
	position: absolute;
	left: 50px;
	top: 0;
	background: var(--card-bg);
	border: 1px solid var(--border-color);
	border-radius: 6px;
	box-shadow: var(--dropdown-shadow, 0 4px 12px rgba(0, 0, 0, 0.1));
	min-width: 200px;
	z-index: 1000;
	padding: 4px;
	transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.dropdown-item {
	padding: 8px 12px;
	cursor: pointer;
	border-radius: 4px;
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	color: var(--text-primary);
	transition: all 0.2s;
}

.dropdown-item:hover {
	background: var(--hover-bg, rgba(58, 105, 250, 0.1));
	color: var(--primary-color, #0156DC);
}

.dropdown-item.selected {
	background: var(--active-bg, rgba(58, 105, 250, 0.15));
	color: var(--primary-color, #0156DC);
	font-weight: 600;
}

.tool-icon {
	font-size: 16px;
	width: 20px;
	text-align: center;
}
</style>

